export const SET_FACILITIES_FOR_DROPDOWN = 'SET_FACILITIES_FOR_DROPDOWN';
export const GET_FACILITIES_FOR_DROPDOWN = 'GET_FACILITIES_FOR_DROPDOWN';